
import React from 'react';
import { FreePassHero } from '../NewComponents/sections/FreePassHero';
import { BookingForm } from '../NewComponents/ui/BookingForm';
import { Header } from '../NewComponents/layout/Header';
import { Footer } from '../NewComponents/layout/Footer';
import { FAQSection } from '../NewComponents/sections/FAQSection';

const FreeDayPass = () => {
  return (
    <div className="min-h-screen w-[100vw] overflow-hidden bg-white">
      <Header/>
      <FreePassHero />
      <section id="book-a-tour" className="flex flex-col relative min-h-[500px] sm:min-h-[700px] w-full items-center justify-center">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/156ea696819743bb881fd4ebbe99ea1e/aee299f0c384dc107aef94849b0999b11e9fb8b1?placeholderIfAbsent=true"
          alt="Background"
          className="absolute h-full w-full object-cover inset-0"
        />
        <div className="relative w-full max-w-[1200px] flex flex-col lg:flex-row items-center px-4 sm:px-6 lg:px-8 py-8 sm:py-12 gap-8 lg:gap-0">
          <div className="w-full lg:w-1/2 mb-4 lg:mb-0 lg:pr-8 text-center lg:text-left">
            <h2 style={{lineHeight:1.5}} className="text-white text-2xl sm:text-3xl lg:text-4xl font-regrade font-semibold mb-4">
              Experience Offis Bay with<br/> a Free Day Pass
            </h2>
            <p className="text-white text-base sm:text-lg">
              Try our workspace for a full day<br className="hidden sm:block"/> at no cost - no strings attached
            </p>
          </div>
          <div className="w-full lg:w-1/2">
            <BookingForm isFreeDayPass={true} />
          </div>
        </div>
      </section>
      <FAQSection/>
      <Footer/>
    </div>
  );
};

export default FreeDayPass;
